import {PARTS_ACTIONS} from "../actions/types";
import {UPDATE_PARTS_LIST, UPDATE_PARTS_RELATIONS} from "../actions";
import {updateCache} from "ith-redux-helpers";
import {filterObject, mapObject} from "../misc/tree-handler";

const defaultState = {
	list: {},
	expansion: {},
	relations: {}
};

const mapOne = (part, old = {}) => ({...old, ...part});

const mapList = (old, list) => {
	return mapObject(list, part => {
		const oldOne = old[part.part_id] || {};
		return {
			...oldOne,
			...part
		};
	});
};

export default (state = defaultState, {type, part, list, part_id, relations, expandIndex, expanded, relation}) => {
	switch (type) {
		case PARTS_ACTIONS.EXPAND:
			return {
				...state,
				// list: mapObject(state.list, part => part.part_id === part_id ? {...part, expanded} : part)
				expansion: {
					...state.expansion,
					[expandIndex]: expanded
				}
			};
		case PARTS_ACTIONS.SET_LIST_RELATIONS:
			return {
				...state,
				list: mapList(state.list, list),
				relations,
				...updateCache(UPDATE_PARTS_LIST),
				...updateCache(UPDATE_PARTS_RELATIONS)
			};
		case PARTS_ACTIONS.SET_ONE:
			return {
				...state,
				list: {
					...state.list,
					[part.part_id]: mapOne(part, state.list[part.part_id])
				},
				...updateCache(UPDATE_PARTS_LIST)
			};
		case PARTS_ACTIONS.SET_LIST:
			return {
				...state,
				list: mapList(state.list, list),
				...updateCache(UPDATE_PARTS_LIST)
			};
		case PARTS_ACTIONS.REMOVE_ONE:
			const delete_id = part ? part.part_id : part_id;
			return {
				...state,
				list: filterObject(state.list, ({part_id}) => part_id !== delete_id),
				relations: filterObject(state.relations, ({parent_id, child_id}) => parent_id !== delete_id && child_id !== delete_id),
				...updateCache(UPDATE_PARTS_LIST),
				...updateCache(UPDATE_PARTS_RELATIONS)
			};
		case PARTS_ACTIONS.SET_RELATION:
			return {
				...state,
				relations: {
					...state.relations,
					[relation.parent_id]: state.relations[relation.parent_id].map(rel => rel.child_id === relation.child_id ? relation : rel)
				},
				...updateCache(UPDATE_PARTS_RELATIONS)
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/partsReducer.js